/**
 * Component: Header navigation
 *
 * Dependencies:
 * - OwlCarousel 2.x.x
 */

var prongHorn = prongHorn || {};

prongHorn.cart = prongHorn.cart || function() {
    var self = this;

    this.init = function() {
        self.toggleDeliveryAddress();
        self.validateCheckout();

    };

    this.toggleDeliveryAddress = function() {
    	var $trigger = $('#AlternativeAddress');
    	var $el = $('.js-delivery-address');

    	$trigger.on('change', function(){
    		var $this = $(this);

    		if($this.is(':checked')) {
    			$el.removeClass('hidden');
    		} else {
    			$el.addClass('hidden');
    		}
    	})
    }

    this.validateCheckout = function() {


    	$('#ordersubmit').parsley({
    		excluded: "input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled], .no-validate, :hidden",
    		errorClass: 'has-error',
    		successClass: '',
    		classHandler: function (ParsleyField) {
    		  return ParsleyField.$element.parents('.form-group');
    		},
    		errorsContainer: function (ParsleyField) {
    		  return ParsleyField.$element.parents('.form-group');
    		},
    		errorsWrapper: '<span class="help-block">',
    		errorTemplate: '<div></div>'
    	});

    }



    // Public functions
    return {
        init: init
    };

}();
